import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

import { StyleClassModule } from 'primeng/styleclass';
import { AppBreadcrumb } from './app.breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '../../../components/auth/data-access/auth.service';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { filter, map, startWith } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { TenantContextService } from '../../../components/auth/data-access/tenant-access.service';

@Component({
  selector: '[app-topbar]',
  standalone: true,
  imports: [
    RouterModule,
    StyleClassModule,
    AppBreadcrumb,
    InputTextModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    AvatarModule,
    TooltipModule
],
  templateUrl: 'app.topbar.html',
})
export class AppTopbar {
  // inject
  public authService = inject(AuthService);
  public layoutService = inject(LayoutService);
  private router = inject(Router);
  private tenantContextService = inject(TenantContextService);

  // public
  public inSuperAdminSignal = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url.startsWith('/super-admin')),
      startWith(this.router.url.startsWith('/super-admin'))
    ),
    { initialValue: this.router.url.startsWith('/super-admin') }
  );

  public initialsComputed = computed(() => {
    return (
      this.authService.authUserComputedSignal()?.firstName[0] +
      '' +
      this.authService.authUserComputedSignal()?.lastName[0]
    );
  });

  public activeCourseNameComputed = computed(() => {
    return this.tenantContextService.selectedCourse()?.displayName;
});

  public isSuperAdminComputed = this.authService.isSuperAdminComputedSignal();
  @ViewChild('menubutton') menuButton!: ElementRef;

  // private

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick() {
    this.layoutService.showProfileSidebar();
  }

  gotoSuperAdmin() {
    this.router.navigateByUrl('/super-admin');
  }
  gotoLiveOrders() {
    this.router.navigateByUrl('/orders/live');
  }

  onChangeCourseClick() {
    this.layoutService.showCourseSidebar();
  }
}
